export class HeaderDesktop {
  private header: HTMLElement | null;
  private overlay: Element | null;
  private menuItems: NodeListOf<Element>;
  private submenus: NodeListOf<HTMLElement>;

  constructor() {
    this.header = document.querySelector('.header-desktop');
    this.overlay = document.querySelector('.header__overlay');
    this.menuItems = document.querySelectorAll('.header-desktop__menu-item.menu-item-has-children');
    this.submenus = document.querySelectorAll('.header-desktop__submenu');

    this.init();
  }

  private init(): void {
    this.handleScroll();
    this.handleOverlay();
    this.handleSubmenuHover();
  }

  private handleScroll(): void {
    if (!this.header) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 0) {
        this.header?.classList.add('scrolled');
      } else {
        this.header?.classList.remove('scrolled');
      }
    });
  }

  private handleOverlay(): void {
    if (!this.overlay) return;

    this.menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        this.overlay?.classList.add('active');
      });

      item.addEventListener('mouseleave', () => {
        this.overlay?.classList.remove('active');
      });
    });

    this.submenus.forEach(submenu => {
      submenu.addEventListener('mouseenter', () => {
        this.overlay?.classList.add('active');
      });

      submenu.addEventListener('mouseleave', () => {
        this.overlay?.classList.remove('active');
      });
    });
  }

  private handleSubmenuHover(): void {
    this.menuItems.forEach((item, index) => {
      const submenu = this.submenus[index];
      if (!submenu) return;

      item.addEventListener('mouseenter', () => {
        submenu.classList.add('active');
        item.classList.add('submenu-active');
      });

      item.addEventListener('mouseleave', () => {
        submenu.classList.remove('active');
        item.classList.remove('submenu-active');
      });

      submenu.addEventListener('mouseenter', () => {
        submenu.classList.add('active');
        item.classList.add('submenu-active');
      });

      submenu.addEventListener('mouseleave', () => {
        submenu.classList.remove('active');
        item.classList.remove('submenu-active');
      });
    });
  }
}
